import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: 'payment-runs',
        loadChildren: () => import('./features/payment-runs/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'todo',
        loadChildren: () => import('./features/todos/todos.module').then(m => m.TodosModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'search',
        loadChildren: () => import('./features/employee-search/employee-search.module').then(m => m.EmployeeSearchModule)
      },
      {
        path: 'legal-entity-setup',
        loadChildren: () => import('./features/legal-entity-overview/legal-entity-overview.module').then(m => m.LegalEntityOverviewModule)
      },
      {
        path: 'employee',
        loadChildren: () => import('./features/employee-detail/employee-detail.module').then(m => m.EmployeeDetailModule)
      },
      {
        path: 'broadcast',
        loadChildren: () => import('./features/broadcast/broadcast.module').then(m => m.BroadcastModule)
      },
      {
        path: 'exclude-dma-accounts',
        loadChildren: () => import('./features/exclude-dma-accounts/exclude-dma-accounts.module').then(m => m.ExcludeDmaAccountsModule)
      },
      {
        path: 'payment-mandate',
        loadChildren: () => import('./features/payment-mandate/payment-mandate.module').then(m => m.PaymentMandateModule)
      },
      {
        path: 'add-credit-card',
        loadChildren: () => import('./features/add-credit-card/add-credit-card.module').then(m => m.AddCreditCardModule)
      },
      {
        path: 'add-debit-card',
        loadChildren: () => import('./features/add-debit/add-debit-card.module').then(m => m.AddDebitCardModule)
      },
      {
        path: 'manage-employees',
        loadChildren: () => import('./features/manage-employees/manage-employees.module').then(m => m.ManageEmployeesModule)
      },
      {
        path: 'manage-users',
        loadChildren: () => import('./features/manage-users/manage-users.module').then(m => m.ManageUsersModule)
      },
      {
        path: 'manage-products',
        loadChildren: () => import('./features/manage-products/manage-products.module').then(m => m.ManageProductsModule)
      },
      {
        path: 'product-configuration',
        loadChildren: () => import('./product-configuration.module').then(m => m.ProductConfigurationModule)
      },
      {
        path: 'legal-entities',
        loadChildren: () => import('./features/legal-entities/legal-entities.module').then(m => m.LegalEntitiesModule)
      },
      {
        path: 'product-solutions',
        loadChildren: () => import('./features/product-solutions/product-solutions.module').then(m => m.ProductSolutionsModule)
      },
      {
        path: 'employee-group-setup',
        loadChildren: () => import('./features/employee-group-setup/employee-group-setup.module').then(m => m.EmployeeGroupSetupModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./features/products/products.module').then(m => m.ProductsModule)
      },
      {
        path: 'product-detail',
        loadChildren: () => import('./features/product-details/product-details.module').then(m => m.ProductDetailsModule)
      },
      {
        path: 'legal-entity-overview',
        loadChildren: () => import('./features/legal-entity-overview/legal-entity-overview.module').then(m => m.LegalEntityOverviewModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule)
      }
      ,
      {
        path: 'entity-dashboard',
        loadChildren: () => import('./features/entity-dashboard/entity-dashboard.module').then(m => m.EntityDashboardModule)
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule)
      },
      {
        path: 'admin-dashboard',
        loadChildren: () => import('./features/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule)
      },
      {
        // Admin Dashboard scoped to the currently selected legal entity (opened from the left nav)
        path: 'entity-admin-dashboard',
        data: { legalEntityScoped: true },
        loadChildren: () => import('./features/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule)
      },
      {
        path: 'asq',
        loadChildren: () => import('./features/asq/asq.module').then(m => m.AsqModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
